import { isNaN } from 'lodash';

export const nanToDefaultNull = (value) => (isNaN(value) ? 0 : value);
